import * as PhotoApi from 'unsplash-js/src/methods/photos/types';

import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Photos } from 'unsplash-js/dist/methods/search/types/response';
import { ReplaySubject } from 'rxjs';
import { UnsplashRequest } from '@models/collection/unsplash-request';
import { environment } from '@environments/environment';
import { unset } from 'lodash';

@Injectable()
export class UnsplashService {
  private subject$: ReplaySubject<Photos> = new ReplaySubject<Photos>(1);

  readonly collection$: Observable<Photos> = this.subject$.asObservable();

  private collection!: Photos;

  randomKeyWords: string[] = [
    'parents',
    'wisdom',
    'legacy',
    'knowledge',
    'family',
    'inspiration',
    'life experience',
    'golden years',
  ];
  randomIndex = Math.floor(Math.random() * this.randomKeyWords.length);
  private request: UnsplashRequest = {
    client_id: environment.externalGallery.unsplash.token,
    page: 1,
    per_page: 12,
    query: this.randomKeyWords[this.randomIndex],
    w: 1500,
  };

  readonly requestChange$: EventEmitter<UnsplashRequest> =
    new EventEmitter<UnsplashRequest>();

  readonly clear$: EventEmitter<UnsplashRequest> =
    new EventEmitter<UnsplashRequest>();

  isLoading = false;

  get results(): PhotoApi.Basic[] {
    return this.collection.results;
  }

  get page(): number {
    return this.request?.page ?? 1;
  }
  set page(page: number) {
    this.setOptionValue('page', page);
  }

  get per_page(): number {
    return this.request?.per_page ?? 12;
  }

  get options(): UnsplashRequest {
    return this.request;
  }

  get from(): number {
    return (this.page - 1) * this.per_page + 1;
  }

  get to(): number {
    return Math.min(this.page * this.per_page, this.collection?.total ?? 0);
  }

  get total(): number {
    return this.collection?.total ?? 0;
  }

  setOptionValue(optionSlug: string, optionValue: any): void {
    unset(this.request, optionSlug);
    let params = {
      ...this.request,
      page: 1,
    };
    if (optionValue !== null) {
      params = {
        ...params,
        [optionSlug]: optionValue,
      };
    }
    this.setOptions(params);
  }

  private setOptions(options: UnsplashRequest): void {
    this.request = options;
    this.requestChange$.emit(options);
  }

  setList(list: Photos): void {
    this.collection = list;
    this.subject$.next(this.collection);
  }

  init(options: UnsplashRequest): void {
    this.request = options;
    this.requestChange$.emit(options);
  }
  clear(options: UnsplashRequest): void {
    this.clear$.emit(options);
  }
}
